import DETAILS from "@constants/shopDetails";

const Map = ({location, height = "250"}) => {
    const {name} = DETAILS;

    return (
        <>
            {
                location?.length > 0 && location?.map(item => (
                    <iframe
                        src={item.location}
                        title={name}
                        width="100%"
                        height={height}
                        frameBorder="0"
                        aria-hidden="false"
                        tabIndex="0"
                        className={"mb-1"}
                    />
                ))
            }
        </>

    );
};

export default Map;
